import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedataService {
  private subject = new Subject<any>();
  sendAddress(data) {    
    this.subject.next(data);
  }
  getAddress(): Observable<any>{ 
    return this.subject.asObservable();
  }

  constructor() { }
}